import './JewelleryDetailImages.svelte.css';
/* src/components/JewelleryDetail/JewelleryDetailImages.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_store_value,
	set_style,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';
import Modal from '../../../_snowpack/pkg/svelte-simple-modal.js';
import JewelleryDetailModal from './JewelleryDetailModal.svelte.js';
import { jewelleryImagesCurrentIndex } from '../../stores/storeJewelleryDetail.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	child_ctx[5] = i;
	return child_ctx;
}

// (31:1) {#if jewellery.images[$jewelleryImagesCurrentIndex]}
function create_if_block(ctx) {
	let img;
	let img_id_value;
	let img_src_value;
	let img_alt_value;

	return {
		c() {
			img = element("img");
			attr(img, "id", img_id_value = "litImageView-" + /*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]].type);
			attr(img, "class", "litImageView litCurrentImageView svelte-466j68");
			if (!src_url_equal(img.src, img_src_value = /*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]].srcm)) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*getImageAlt*/ ctx[2](/*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]].type) + "画像"));
			attr(img, "decoding", "auto");
			attr(img, "loading", "eager");
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*jewellery, $jewelleryImagesCurrentIndex*/ 3 && img_id_value !== (img_id_value = "litImageView-" + /*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]].type)) {
				attr(img, "id", img_id_value);
			}

			if (dirty & /*jewellery, $jewelleryImagesCurrentIndex*/ 3 && !src_url_equal(img.src, img_src_value = /*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]].srcm)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*jewellery, $jewelleryImagesCurrentIndex*/ 3 && img_alt_value !== (img_alt_value = "" + (/*getImageAlt*/ ctx[2](/*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]].type) + "画像"))) {
				attr(img, "alt", img_alt_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (54:3) <Modal>
function create_default_slot(ctx) {
	let jewellerydetailmodal;
	let t;
	let current;

	jewellerydetailmodal = new JewelleryDetailModal({
			props: {
				targetSrc: /*img*/ ctx[3].srcx,
				thumbSrc: /*img*/ ctx[3].srcs,
				imgTypeText: /*img*/ ctx[3].type,
				imgIndex: /*imgIndex*/ ctx[5]
			}
		});

	return {
		c() {
			create_component(jewellerydetailmodal.$$.fragment);
			t = space();
		},
		m(target, anchor) {
			mount_component(jewellerydetailmodal, target, anchor);
			insert(target, t, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const jewellerydetailmodal_changes = {};
			if (dirty & /*jewellery*/ 1) jewellerydetailmodal_changes.targetSrc = /*img*/ ctx[3].srcx;
			if (dirty & /*jewellery*/ 1) jewellerydetailmodal_changes.thumbSrc = /*img*/ ctx[3].srcs;
			if (dirty & /*jewellery*/ 1) jewellerydetailmodal_changes.imgTypeText = /*img*/ ctx[3].type;
			jewellerydetailmodal.$set(jewellerydetailmodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(jewellerydetailmodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(jewellerydetailmodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(jewellerydetailmodal, detaching);
			if (detaching) detach(t);
		}
	};
}

// (53:2) {#each jewellery.images as img, imgIndex}
function create_each_block(ctx) {
	let modal;
	let current;

	modal = new Modal({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(modal.$$.fragment);
		},
		m(target, anchor) {
			mount_component(modal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const modal_changes = {};

			if (dirty & /*$$scope, jewellery*/ 65) {
				modal_changes.$$scope = { dirty, ctx };
			}

			modal.$set(modal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(modal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(modal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(modal, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let t0;
	let p;
	let span;
	let t1;
	let t2;
	let div0;
	let current;
	let if_block = /*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]] && create_if_block(ctx);
	let each_value = /*jewellery*/ ctx[0].images;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			div1 = element("div");
			if (if_block) if_block.c();
			t0 = space();
			p = element("p");
			span = element("span");
			t1 = text("クリックで画像を拡大できます。");
			t2 = space();
			div0 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			set_style(span, "background", "url(" + (/*jewellery*/ ctx[0].assetsUrl + '/bg_info_click.gif') + ") left center no-repeat");
			attr(span, "class", "svelte-466j68");
			attr(p, "class", "info-click svelte-466j68");
			attr(div0, "class", "jewellery-image-list svelte-466j68");
			attr(div1, "class", "jewellery-images svelte-466j68");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			if (if_block) if_block.m(div1, null);
			append(div1, t0);
			append(div1, p);
			append(p, span);
			append(span, t1);
			append(div1, t2);
			append(div1, div0);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div0, null);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (/*jewellery*/ ctx[0].images[/*$jewelleryImagesCurrentIndex*/ ctx[1]]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div1, t0);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (!current || dirty & /*jewellery*/ 1) {
				set_style(span, "background", "url(" + (/*jewellery*/ ctx[0].assetsUrl + '/bg_info_click.gif') + ") left center no-repeat");
			}

			if (dirty & /*jewellery*/ 1) {
				each_value = /*jewellery*/ ctx[0].images;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div0, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
			destroy_each(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $jewelleryImagesCurrentIndex;
	component_subscribe($$self, jewelleryImagesCurrentIndex, $$value => $$invalidate(1, $jewelleryImagesCurrentIndex = $$value));
	let { jewellery } = $$props;

	const getImageAlt = type => {
		let alt = 'イメージ';

		if ('product' === type) {
			alt = '商品';
		} else if ('condition' === type) {
			alt = '品質確認';
		}

		return alt;
	};

	set_store_value(jewelleryImagesCurrentIndex, $jewelleryImagesCurrentIndex = 0, $jewelleryImagesCurrentIndex);

	onMount(() => {
		jewellery.images.forEach((obj, index) => {
			if ('product' === obj.type) {
				set_store_value(jewelleryImagesCurrentIndex, $jewelleryImagesCurrentIndex = index, $jewelleryImagesCurrentIndex);
			}
		});
	});

	$$self.$$set = $$props => {
		if ('jewellery' in $$props) $$invalidate(0, jewellery = $$props.jewellery);
	};

	return [jewellery, $jewelleryImagesCurrentIndex, getImageAlt];
}

class JewelleryDetailImages extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { jewellery: 0 });
	}
}

export default JewelleryDetailImages;